import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'formContact/MessageConfirm';

export const Wrapper = styled.div`
  font-size: 18px;
  font-family: ${FONTS.MONTSERRAT};
  color: ${COLORS.GRAY_DARK};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12% 0 20%;
  justify-content: center;
`;

Wrapper.className = `${ROOT}/Wrapper`;

export const Title = styled.h3`
  font-family: ${FONTS.MONTSERRAT_BOLD};
  font-size: 21px;
  color: ${COLORS.VIOLET_HIGHLIGHT};
  margin-bottom: 10px;
  max-width: 268px;
`;

Title.className = `${ROOT}/Title`;

export const Text = styled.p`
  margin-bottom: 32px;
  text-align: center;
`;

Text.className = `${ROOT}/Text`;

export const LeadName = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 16px;
`;

LeadName.className = `${ROOT}/LeadName`;

export const LeadMail = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 18px;
  margin-bottom: 16px;
  word-break: break-all;
  display: flex;
  text-align: center;
  span {
    margin-left: 18px;
  }
`;

LeadMail.className = `${ROOT}/LeadMail`;

export const LeadPhone = styled.a`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  span {
    margin-left: 18px;
  }
`;

LeadPhone.className = `${ROOT}/LeadPhone`;

export const ButtonWhatsapp = styled.a`
  display: flex;
  align-items: center;
  background: #01D82A;
  border-radius: 4px;
  color: #fff;
  width: 276px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 17px;
  font-family: ${FONTS.OPEN_SANS};
  font-weight: 600;
  span {
    margin-left: 16px;
  }
`;

ButtonWhatsapp.className = `${ROOT}/ButtonWhatsapp`;
